import { Button, DatePicker, TimePicker, Space } from "antd";
import dayjs from "dayjs";
import React, { useState } from "react";

export default function FilterDateTime({ closeModelFilter, onFilterDateChange }) {
  const [FilterDate, setFilterDate] = useState({
    date_start: null,
    time_start: null,
    date_end: null,
    time_end: null,
  });

  // Date Start
  const handleDateStart = (date) => {
    setFilterDate({
      ...FilterDate,
      date_start: date ? dayjs(date).format("YYYY-MM-DD") : null,
    });
  };

  // Time Start
  const handleTimeStart = (time) => {
    setFilterDate({
      ...FilterDate,
      time_start: time ? dayjs(time).format("HH:mm") : null,
    });
  };

  // Date End
  const handleDateEnd = (date) => {
    setFilterDate({
      ...FilterDate,
      date_end: date ? dayjs(date).format("YYYY-MM-DD") : null,
    });
  };

  // Time End
  const handleTimeEnd = (time) => {
    setFilterDate({
      ...FilterDate,
      time_end: time ? dayjs(time).format("HH:mm") : null,
    });
  };

  const modelFilterSearch = () => {
    console.log("FilterDate:", FilterDate);
    if (onFilterDateChange) {
      onFilterDateChange(FilterDate); // send to parent
    }
  };

  return (
    <>
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        {/* Start Section */}
        <Space>
          <span>ចាប់ពីថ្ងៃទី:</span>
          <DatePicker format="DD/MM/YYYY" onChange={handleDateStart} />
          <TimePicker format="HH:mm" onChange={handleTimeStart} />
        </Space>

        {/* End Section */}
        <Space>
          <span>ដល់ថ្ងៃទី:</span>
          <DatePicker format="DD/MM/YYYY" onChange={handleDateEnd} />
          <TimePicker format="HH:mm" onChange={handleTimeEnd} />
        </Space>
      </Space>

      {/* Buttons */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "20px",
        }}
      >
        <Space>
          <Button danger onClick={closeModelFilter}>
            បិទ
          </Button>
          <Button type="primary" onClick={modelFilterSearch}>
            ទាញរបាយការណ៍
          </Button>
        </Space>
      </div>
    </>
  );
}
